(function() { window.GUID_a5e5deba_f5e5_4817_9baa_f051807ee8ac = { getGuid: function() { return "a5e5deba-f5e5-4817-9baa-f051807ee8ac"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SVGIcon;
        (function (SVGIcon) {
            SVGIcon[SVGIcon["Clock"] = 0] = "Clock";
            SVGIcon[SVGIcon["GridLayout"] = 1] = "GridLayout";
            SVGIcon[SVGIcon["CardLayout"] = 2] = "CardLayout";
            SVGIcon[SVGIcon["QuickTournamentIllustration"] = 3] = "QuickTournamentIllustration";
            SVGIcon[SVGIcon["Charts"] = 4] = "Charts";
            SVGIcon[SVGIcon["Videos"] = 5] = "Videos";
            SVGIcon[SVGIcon["Favorites"] = 6] = "Favorites";
            SVGIcon[SVGIcon["Notifications"] = 7] = "Notifications";
            SVGIcon[SVGIcon["Info"] = 8] = "Info";
            SVGIcon[SVGIcon["InfoYellow"] = 9] = "InfoYellow";
        })(SVGIcon = Enumeration.SVGIcon || (Enumeration.SVGIcon = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SVGIcon.pre.js.map
